import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "row", "removeBtn"]

  connect() {
    this.toggleRemoveButtons()
  }

  add() {
    const template = this.rowTargets[0].cloneNode(true)
    template.querySelectorAll("input").forEach(input => { input.value = "" })
    template.querySelectorAll("select").forEach(select => { select.selectedIndex = 0 })
    template.querySelectorAll("textarea").forEach(textarea => {
      textarea.value = ""
      textarea.textContent = ""
    })
    this.containerTarget.appendChild(template)
    this.toggleRemoveButtons()
  }

  remove(event) {
    if (this.rowTargets.length > 1) {
      event.currentTarget.closest("[data-line-items-target='row']").remove()
      this.toggleRemoveButtons()
    }
  }

  toggleRemoveButtons() {
    const showRemove = this.rowTargets.length > 1
    this.removeBtnTargets.forEach(btn => {
      btn.classList.toggle("hidden", !showRemove)
    })
  }
}
